import { Panel, Section } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { getThemeByType } from 'utils/common';
import { FieldsSelection, FilterCriteria__REFACTORED, ViewActions, ViewName, ViewVisibility } from '../components/index';
import { resetView, isLoadFetchUserAndFetchViewId } from '../flow/actions';

const sections = [
  {
    titleI18n: 'viewName',
    component: ViewName,
    extraProps: {},
  },
  {
    titleI18n: 'criteria',
    component: FilterCriteria__REFACTORED,
    extraProps: {
      needSearchBar: true
    }
  },
  {
    titleI18n: 'selectors',
    component: FieldsSelection,
    extraProps: {
      needSearchBar: true
    },
  },
  {
    titleI18n: 'visibility',
    component: ViewVisibility,
    extraProps: {},
  },
];


const defaultProps = {
};
const propTypes = {
  intl: intlShape.isRequired,
  resetView: PropTypes.func.isRequired,
  isLoadFetchUserAndFetchViewId: PropTypes.func.isRequired,
};


class ObjectFilter extends Component {
  componentDidMount() {
    const {
      objectType,
      viewId,
      isLoadFetchUserAndFetchViewId
    } = this.props;
    // Cause 'view_name' will be clear when the component unmount, there are no 'view_name' when click the edit view button or refresh the page.
    // This condition is checking the source entrance that the objectView page is creating new view or not.
    isLoadFetchUserAndFetchViewId(viewId, objectType);
  }

  componentWillUnmount() {
    this.props.resetView();
  }

  render() {
    const {
      intl,
      objectType,
      viewId,
      needSearchBar
    } = this.props;
    const theme = getThemeByType(objectType);
    const { formatMessage } = intl;
    const i18n = 'page.objectFilter';

    const titleId = viewId === Enums.PhantomId ? 'general.newTitle' : 'general.existTitle';

    return (
      <Panel
        panelClasses={`${theme}-theme-panel`}
        panelTitle={formatMessage({ id: `${i18n}.${titleId}` })}
      >
        {sections.map((section, i) => {
          const id = `${i18n}.${section.titleI18n}.stepName`;
          const stepName = formatMessage({ id });
          return (
            <Section
              key={i}
              title={`${i + 1}. ${stepName}`}
            >
              {section.titleI18n === 'criteria'
                ? <FilterCriteria__REFACTORED theme={theme} objectType={objectType} {...section.extraProps} />
                : <section.component theme={theme} needSearchBar={needSearchBar} {...section.extraProps} />}
            </Section>
          );
        })}
        <ViewActions
          objectType={objectType}
          theme={theme}
          viewId={viewId}
        />
      </Panel>
    );
  }
}

ObjectFilter.defaultProps = defaultProps;
ObjectFilter.propTypes = propTypes;
const mapStateToProps = ({ global }) => ({
  language: global.language,
});
const mapDispatchToProps = {
  resetView,
  isLoadFetchUserAndFetchViewId
};
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ObjectFilter));



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/container/index.jsx